const config = {
  development: {
    DIRECT_UPLOAD_BUCKET: "867089416966-gg-web-stg-attachments",
    CONTENT_URL: "https://attachments-staging.govoutreach.com",
    ATTACHMENTS_URL: "https://attachments.govoutreach.com",
    GOOGLE_MAP_KEY: "",
    GOOGLE_GEOCODING_KEY: "AIzaSyDU1L0LwwZGDEOK7BfzwWiEwDN61pxOWxs",
    ARCGIS_API_KEY:
      "AAPTxy8BH1VEsoebNVZXo8HurAf48IufKZdUJlhBoLKFbTf8sK9MEoFyrJ59hq3sMsTbBquPcj8PF8jwfaiJt5r1PEzjgkkloFePx0O7vfvuhHAtElLn4um3u8qRLOGrS4H8-s2qUI_0cNI2AH6pZ67-7cxQ6Vf0yO7d776r6FlqLvJ5dSvt5vOCavEv3amAndE6MZjdYtplcb3Vxfl4ktcbjc85qaJ6_ov70Mcl9ABydqs.AT1_j96gVLgS",
    GOGOV_APP_URL: "http://localhost:3001",
    GOGOV_WEB_API_URL: "https://localhost",
    GOGOV_WEB_URL: "https://localhost",
    GOGOV_MOBILE_URL: "https://localhost",
    GOGOV_BASE_API_URL: "http://localhost:3010",
    CITIZEN_API_URL: "http://localhost:3010/citizen",
    CITIZENS_API_URL: "http://localhost:3010/citizens/citizens",
    IDENTITY_API_URL: "http://localhost:3010/users/users",
    PRODUCTS_API_URL: "https://api.staging.govoutreach.com/products",
    ADMIN_API_URL: "http://localhost:3010/admin",
    INTERNAL_ADMIN_API_URL: "https://internal-admin.staging.govoutreach.com/api",
    CALENDARS_API_URL: "https://api.staging.govoutreach.com/calendars",
    DIRECT_UPLOAD_API_URL: "https://api.staging.govoutreach.com/uploads",
    FILE_UPLOAD_API_URL: "http://localhost:3010/core/file",
    CORE_MOBILE_API_URL: "http://localhost:3010/core/mobile",
    EMPLOYEES_API_URL: "http://localhost:3010/employees/employees",
    DEPARTMENTS_API_URL: "http://localhost:3010/employees/departments",
    SEARCH_API_URL: "http://localhost:3010/search",
    CRM_CUSTOM_FIELDS_API_URL: "http://localhost:3010/custom_fields/crm/custom-fields",
    NOTIFICATIONS_API_URL: "http://localhost:3010/notifications",
    CE_SETTINGS_API_URL: "http://localhost:3010/admin/code",
    CE_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/ce/custom-fields",
    PERMITS_FORMS_API_URL: "http://localhost:3010/permits/permits/forms",
    PERMITS_INSPECTION_TYPES_API_URL: "https://api.staging.govoutreach.com/inspections/types",
    PERMITS_INSPECTION_API_URL: "https://api.staging.govoutreach.com/inspections",
    PERMITS_TYPES_API_URL: "http://localhost:3010/permits/permits/types",
    PERMITS_VIEWS_API_URL: "http://localhost:3010/permits/permits/views",
    PERMITS_API_URL: "http://localhost:3010/permits/permits",
    PERMITS_STATUSES_API_URL: "http://localhost:3010/permits/statuses",
    COMMENTS_API_URL: "http://localhost:3010/comments/comments",
    PAYMENTS_API_URL: "http://localhost:3010/payments/payments",
    DOCUMENT: "https://api.staging.govoutreach.com/documents",
    DOCUMENT_TYPES: "https://api.staging.govoutreach.com/documents/types",
    DOCUMENT_SETTINGS: "http://localhost:3010/admin/documents",
    FEATURE_FLAGS_API_URL: "http://localhost:3010/core/feature-flags",
    ASSETS_URL: "https://assets-staging.govoutreach.com",
    INTERNAL_ADMIN_URL: "https://internal-admin.staging.govoutreach.com",
    SYSTEM_STATUS_URL: undefined,
    SENTRY_DSN: "https://143adbbe09b44249bb1c406a01b0fdac@o396450.ingest.sentry.io/5252806",
    STRIPE_TEST_PUBLIC_KEY:
      "pk_test_51Ij9KVDsqRmHarDvH3TkwaDO8qWMYQX4HHvOaYcwHw778vkslbRnsFMRzv5YOCVhl8AwZBMZrCfLv94Cq3nyB5te00pa1TI5fg",
    STRIPE_LIVE_PUBLIC_KEY:
      "pk_live_51Ij9KVDsqRmHarDvZHiL7Hkl1JBGJa92KJbXgPV6eWLzDvOHXuMtKaa5UsAeHGFna52U700G41VO9BYpPctmtMUP000YS7M36w",
    FORCE_NEW_LOOK_LISTS: true,
    MIXPANEL_TOKEN: "f11dfba8d1143733d77c4856ba2eed62",
    DATADOG_RUM_TOKEN: undefined,
    DATADOG_RUM_APP_ID: undefined,
    DISABLE_IMPORTS: false,
    DISABLE_EVENT_LOG: false,
    DISABLE_UPLOAD_TOOL: false,
    LOCAL_DEV_ENV: true,
    CONTACTS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/ContactsStandardImportTemplate.csv",
    MAP_LAYER_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/MapLayerStandardImportTemplate.csv",
    PERMITS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/PermitsStandardImportTemplate.csv",
    PERMIT_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/PermitAttachmentsStandardImportTemplate.csv",
    CRM_REQUESTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CRMRequestsStandardImportTemplate.csv",
    CRM_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CRMAttachmentsStandardImportTemplate.csv",
    CRM_LOGS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/CRMLogsStandardImportTemplate.csv",
    CODE_CASES_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/CodeCasesStandardImportTemplate.csv",
    CODE_ACTIONS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeActionsStandardImportTemplate.csv",
    CODE_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeAttachmentsStandardImportTemplate.csv",
    CODE_VIOLATIONS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeViolationsStandardImportTemplate.csv",
    CODE_ADDRESSES_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeAddressesStandardImportTemplate.csv",
    RELEASE_NOTES_URL: "https://gogov.releasenotes.io/",
    EMAIL_SUPPRESSION_LIST_API_URL: "https://api.staging.govoutreach.com/core/mail/suppression-list",
    OAUTH_REDIRECT_URL: "http://localhost:3001/oauth/callback",
    OAUTH_MICROSOFT_CLIENT_ID: "d976d250-57a3-435a-b311-14d76ab6fe09",
    OAUTH_GOGOV_CLIENT_ID: "ac9475d2-1a58-4ab4-ace2-08b6924af628",
    OAUTH_GOGOV_TENANT_ID: "b1888a2b-e5a6-47f2-b77c-8af32ba3eb36",
    OAUTH_GOOGLE_CLIENT_ID: "542795358459-p468eja8rmvjqrc8i0j0rheiq8verq5k.apps.googleusercontent.com",
    OAUTH_FACEBOOK_CLIENT_ID: "1683404652609537",
    OAUTH_APPLE_CLIENT_ID: "com.govoutreach.authservice",
    OAUTH_APPLE_REDIRECT_URL: "<ngrok url>/users/users/oauth/apple", // For local development, use ngrok to tunnel to local dev env and set this to the forwarding URL

    NOTIFY_FACEBOOK_CLIENT_ID: "2026746284458885",
    NOTIFY_FACEBOOK_CALLBACK_URL: "http://localhost:3001/oauth2/facebook/callback",

    NOTIFY_TWITTER_CLIENT_ID: "bGFLU21fMmRyUEFxNmk2M0hqZXQ6MTpjaQ",
    NOTIFY_TWITTER_CALLBACK_URL: "http://localhost:3001/oauth2/twitter/callback",

    NOTIFY_INSTAGRAM_CLIENT_ID: "551546717959943",
    NOTIFY_INSTAGRAM_CALLBACK_URL: "https://localhost:3001/oauth2/instagram/callback",
    TINY_MCE_API_KEY: "nlfbk6tig41v8p95trrvq0v0aqrtiilhyopfzshv3l2pw3kk",
  },
  development_remote: {
    DIRECT_UPLOAD_BUCKET: "867089416966-gg-web-stg-attachments",
    CONTENT_URL: "https://attachments-staging.govoutreach.com",
    ATTACHMENTS_URL: "https://attachments.govoutreach.com",
    GOOGLE_MAP_KEY: "",
    GOOGLE_GEOCODING_KEY: "AIzaSyDU1L0LwwZGDEOK7BfzwWiEwDN61pxOWxs",
    ARCGIS_API_KEY:
      "AAPTxy8BH1VEsoebNVZXo8HurAf48IufKZdUJlhBoLKFbTf8sK9MEoFyrJ59hq3sMsTbBquPcj8PF8jwfaiJt5r1PEzjgkkloFePx0O7vfvuhHAtElLn4um3u8qRLOGrS4H8-s2qUI_0cNI2AH6pZ67-7cxQ6Vf0yO7d776r6FlqLvJ5dSvt5vOCavEv3amAndE6MZjdYtplcb3Vxfl4ktcbjc85qaJ6_ov70Mcl9ABydqs.AT1_j96gVLgS",
    GOGOV_APP_URL: `http://${import.meta.env.VITE_HOSTNAME}:3001`,
    GOGOV_WEB_API_URL: `https://${import.meta.env.VITE_HOSTNAME}`,
    GOGOV_WEB_URL: `https://${import.meta.env.VITE_HOSTNAME}`,
    GOGOV_MOBILE_URL: `https://${import.meta.env.VITE_HOSTNAME}`,
    GOGOV_BASE_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010`,
    CITIZEN_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/citizen`,
    CITIZENS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/citizens/citizens`,
    IDENTITY_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/users/users`,
    PRODUCTS_API_URL: "https://api.staging.govoutreach.com/products",
    ADMIN_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/admin`,
    INTERNAL_ADMIN_API_URL: "https://internal-admin.staging.govoutreach.com/api",
    CALENDARS_API_URL: "https://api.staging.govoutreach.com/calendars",
    DIRECT_UPLOAD_API_URL: "https://api.staging.govoutreach.com/uploads",
    FILE_UPLOAD_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/core/file`,
    CORE_MOBILE_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/core/mobile`,
    EMPLOYEES_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/employees/employees`,
    DEPARTMENTS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/employees/departments`,
    SEARCH_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/search`,
    CRM_CUSTOM_FIELDS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/custom_fields/crm/custom-fields`,
    NOTIFICATIONS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/notifications`,
    CE_SETTINGS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/admin/code`,
    CE_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/ce/custom-fields",
    PERMITS_FORMS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/permits/permits/forms`,
    PERMITS_INSPECTION_TYPES_API_URL: "https://api.staging.govoutreach.com/inspections/types",
    PERMITS_INSPECTION_API_URL: "https://api.staging.govoutreach.com/inspections",
    PERMITS_TYPES_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/permits/permits/types`,
    PERMITS_VIEWS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/permits/permits/views`,
    PERMITS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/permits/permits`,
    PERMITS_STATUSES_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/permits/statuses`,
    COMMENTS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/comments/comments`,
    PAYMENTS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/payments/payments`,
    DOCUMENT: "https://api.staging.govoutreach.com/documents",
    DOCUMENT_TYPES: "https://api.staging.govoutreach.com/documents/types",
    DOCUMENT_SETTINGS: `http://${import.meta.env.VITE_HOSTNAME}:3010/admin/documents`,
    FEATURE_FLAGS_API_URL: `http://${import.meta.env.VITE_HOSTNAME}:3010/core/feature-flags`,
    ASSETS_URL: "https://assets-staging.govoutreach.com",
    INTERNAL_ADMIN_URL: "https://internal-admin.staging.govoutreach.com",
    SYSTEM_STATUS_URL: undefined,
    SENTRY_DSN: "https://143adbbe09b44249bb1c406a01b0fdac@o396450.ingest.sentry.io/5252806",
    STRIPE_TEST_PUBLIC_KEY:
      "pk_test_51Ij9KVDsqRmHarDvH3TkwaDO8qWMYQX4HHvOaYcwHw778vkslbRnsFMRzv5YOCVhl8AwZBMZrCfLv94Cq3nyB5te00pa1TI5fg",
    STRIPE_LIVE_PUBLIC_KEY:
      "pk_live_51Ij9KVDsqRmHarDvZHiL7Hkl1JBGJa92KJbXgPV6eWLzDvOHXuMtKaa5UsAeHGFna52U700G41VO9BYpPctmtMUP000YS7M36w",
    FORCE_NEW_LOOK_LISTS: true,
    MIXPANEL_TOKEN: "f11dfba8d1143733d77c4856ba2eed62",
    DATADOG_RUM_TOKEN: undefined,
    DATADOG_RUM_APP_ID: undefined,
    DISABLE_IMPORTS: false,
    DISABLE_EVENT_LOG: false,
    DISABLE_UPLOAD_TOOL: false,
    LOCAL_DEV_ENV: true,
    CONTACTS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/ContactsStandardImportTemplate.csv",
    MAP_LAYER_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/MapLayerStandardImportTemplate.csv",
    PERMITS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/PermitsStandardImportTemplate.csv",
    PERMIT_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/PermitAttachmentsStandardImportTemplate.csv",
    CRM_REQUESTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CRMRequestsStandardImportTemplate.csv",
    CRM_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CRMAttachmentsStandardImportTemplate.csv",
    CRM_LOGS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/CRMLogsStandardImportTemplate.csv",
    CODE_CASES_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/CodeCasesStandardImportTemplate.csv",
    CODE_ACTIONS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeActionsStandardImportTemplate.csv",
    CODE_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeAttachmentsStandardImportTemplate.csv",
    CODE_VIOLATIONS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeViolationsStandardImportTemplate.csv",
    CODE_ADDRESSES_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeAddressesStandardImportTemplate.csv",
    RELEASE_NOTES_URL: "https://gogov.releasenotes.io/",
    EMAIL_SUPPRESSION_LIST_API_URL: "https://api.staging.govoutreach.com/core/mail/suppression-list",
    OAUTH_REDIRECT_URL: `http://${import.meta.env.VITE_HOSTNAME}:3001/oauth/callback`,
    OAUTH_MICROSOFT_CLIENT_ID: "d976d250-57a3-435a-b311-14d76ab6fe09",
    OAUTH_GOGOV_CLIENT_ID: "ac9475d2-1a58-4ab4-ace2-08b6924af628",
    OAUTH_GOGOV_TENANT_ID: "b1888a2b-e5a6-47f2-b77c-8af32ba3eb36",
    OAUTH_GOOGLE_CLIENT_ID: "542795358459-p468eja8rmvjqrc8i0j0rheiq8verq5k.apps.googleusercontent.com",
    OAUTH_FACEBOOK_CLIENT_ID: "3485340515103338",
    OAUTH_APPLE_CLIENT_ID: "com.govoutreach.authservice",
    OAUTH_APPLE_REDIRECT_URL: "<ngrok url>/users/users/oauth/apple", // For local development, use ngrok to tunnel to local dev env and set this to the forwarding URL

    NOTIFY_FACEBOOK_CLIENT_ID: "2026746284458885",
    NOTIFY_FACEBOOK_CALLBACK_URL: `http://${import.meta.env.VITE_HOSTNAME}:3001/oauth2/facebook/callback`,

    NOTIFY_TWITTER_CLIENT_ID: "bGFLU21fMmRyUEFxNmk2M0hqZXQ6MTpjaQ",
    NOTIFY_TWITTER_CALLBACK_URL: `http://${import.meta.env.VITE_HOSTNAME}:3001/oauth2/twitter/callback`,

    NOTIFY_INSTAGRAM_CLIENT_ID: "551546717959943",
    NOTIFY_INSTAGRAM_CALLBACK_URL: `https://${import.meta.env.VITE_HOSTNAME}:3001/oauth2/instagram/callback`,
    TINY_MCE_API_KEY: "nlfbk6tig41v8p95trrvq0v0aqrtiilhyopfzshv3l2pw3kk",
  },
  development_staging: {
    DIRECT_UPLOAD_BUCKET: "867089416966-gg-web-stg-attachments",
    CONTENT_URL: "https://attachments-staging.govoutreach.com",
    ATTACHMENTS_URL: "https://attachments.govoutreach.com",
    GOOGLE_MAP_KEY: "",
    GOOGLE_GEOCODING_KEY: "AIzaSyDU1L0LwwZGDEOK7BfzwWiEwDN61pxOWxs",
    ARCGIS_API_KEY:
      "AAPTxy8BH1VEsoebNVZXo8HurAf48IufKZdUJlhBoLKFbTf8sK9MEoFyrJ59hq3sMsTbBquPcj8PF8jwfaiJt5r1PEzjgkkloFePx0O7vfvuhHAtElLn4um3u8qRLOGrS4H8-s2qUI_0cNI2AH6pZ67-7cxQ6Vf0yO7d776r6FlqLvJ5dSvt5vOCavEv3amAndE6MZjdYtplcb3Vxfl4ktcbjc85qaJ6_ov70Mcl9ABydqs.AT1_j96gVLgS",
    GOGOV_APP_URL: "https://app-staging.govoutreach.com",
    GOGOV_WEB_API_URL: "https://user.staging.govoutreach.com",
    GOGOV_WEB_URL: "https://user.staging.govoutreach.com",
    INTERNAL_ADMIN_URL: "https://internal-admin.staging.govoutreach.com",
    GOGOV_MOBILE_URL: "https://m.staging.govoutreach.com",
    GOGOV_BASE_API_URL: "https://api.staging.govoutreach.com",
    CITIZEN_API_URL: "https://api.staging.govoutreach.com/citizen",
    CITIZENS_API_URL: "https://api.staging.govoutreach.com/citizens",
    IDENTITY_API_URL: "https://api.staging.govoutreach.com/users",
    PRODUCTS_API_URL: "https://api.staging.govoutreach.com/products",
    ADMIN_API_URL: "https://api.staging.govoutreach.com/admin",
    INTERNAL_ADMIN_API_URL: "https://internal-admin.staging.govoutreach.com/api",
    CALENDARS_API_URL: "https://api.staging.govoutreach.com/calendars",
    DIRECT_UPLOAD_API_URL: "https://api.staging.govoutreach.com/uploads",
    FILE_UPLOAD_API_URL: "https://api.staging.govoutreach.com/core/file",
    CORE_MOBILE_API_URL: "https://api.staging.govoutreach.com/core/mobile",
    EMPLOYEES_API_URL: "https://api.staging.govoutreach.com/employees",
    DEPARTMENTS_API_URL: "https://api.staging.govoutreach.com/departments",
    SEARCH_API_URL: "https://api.staging.govoutreach.com/search",
    CRM_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/crm/custom-fields",
    NOTIFICATIONS_API_URL: "https://api.staging.govoutreach.com/notifications",
    CE_SETTINGS_API_URL: "https://api.staging.govoutreach.com/admin/code",
    CE_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/ce/custom-fields",
    PERMITS_FORMS_API_URL: "https://api.staging.govoutreach.com/permits/forms",
    PERMITS_INSPECTION_TYPES_API_URL: "https://api.staging.govoutreach.com/inspections/types",
    PERMITS_INSPECTION_API_URL: "https://api.staging.govoutreach.com/inspections",
    PERMITS_TYPES_API_URL: "https://api.staging.govoutreach.com/permits/types",
    PERMITS_VIEWS_API_URL: "https://api.staging.govoutreach.com/permits/views",
    PERMITS_API_URL: "https://api.staging.govoutreach.com/permits",
    PERMITS_STATUSES_API_URL: "https://api.staging.govoutreach.com/permits/statuses",
    COMMENTS_API_URL: "https://api.staging.govoutreach.com/comments",
    PAYMENTS_API_URL: "https://api.staging.govoutreach.com/payments",
    DOCUMENT: "https://api.staging.govoutreach.com/documents",
    DOCUMENT_TYPES: "https://api.staging.govoutreach.com/documents/types",
    DOCUMENT_SETTINGS: "https://api.staging.govoutreach.com/admin/documents",
    FEATURE_FLAGS_API_URL: "https://api.staging.govoutreach.com/core/feature-flags",
    ASSETS_URL: "https://assets-staging.govoutreach.com",
    SYSTEM_STATUS_URL: undefined,
    SENTRY_DSN: "https://143adbbe09b44249bb1c406a01b0fdac@o396450.ingest.sentry.io/5252806",
    STRIPE_TEST_PUBLIC_KEY:
      "pk_test_51Ij9KVDsqRmHarDvH3TkwaDO8qWMYQX4HHvOaYcwHw778vkslbRnsFMRzv5YOCVhl8AwZBMZrCfLv94Cq3nyB5te00pa1TI5fg",
    STRIPE_LIVE_PUBLIC_KEY:
      "pk_live_51Ij9KVDsqRmHarDvZHiL7Hkl1JBGJa92KJbXgPV6eWLzDvOHXuMtKaa5UsAeHGFna52U700G41VO9BYpPctmtMUP000YS7M36w",
    FORCE_NEW_LOOK_LISTS: true,
    MIXPANEL_TOKEN: "f11dfba8d1143733d77c4856ba2eed62",
    DATADOG_RUM_TOKEN: undefined,
    DATADOG_RUM_APP_ID: undefined,
    DISABLE_IMPORTS: false,
    DISABLE_EVENT_LOG: false,
    DISABLE_UPLOAD_TOOL: false,
    LOCAL_DEV_ENV: true,
    CONTACTS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/ContactsStandardImportTemplate.csv",
    MAP_LAYER_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/MapLayerStandardImportTemplate.csv",
    PERMITS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/PermitsStandardImportTemplate.csv",
    PERMIT_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/PermitAttachmentsStandardImportTemplate.csv",
    CRM_REQUESTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CRMRequestsStandardImportTemplate.csv",
    CRM_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CRMAttachmentsStandardImportTemplate.csv",
    CRM_LOGS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/CRMLogsStandardImportTemplate.csv",
    CODE_CASES_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/CodeCasesStandardImportTemplate.csv",
    CODE_ACTIONS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeActionsStandardImportTemplate.csv",
    CODE_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeAttachmentsStandardImportTemplate.csv",
    CODE_VIOLATIONS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeViolationsStandardImportTemplate.csv",
    CODE_ADDRESSES_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeAddressesStandardImportTemplate.csv",
    RELEASE_NOTES_URL: "https://gogov.releasenotes.io/",
    EMAIL_SUPPRESSION_LIST_API_URL: "https://api.staging.govoutreach.com/core/mail/suppression-list",
    OAUTH_REDIRECT_URL: "https://app-staging.govoutreach.com/oauth/callback",
    OAUTH_MICROSOFT_CLIENT_ID: "c512dac5-5f5d-4041-890c-2a7d85be843e",
    OAUTH_GOGOV_CLIENT_ID: "ac9475d2-1a58-4ab4-ace2-08b6924af628",
    OAUTH_GOGOV_TENANT_ID: "b1888a2b-e5a6-47f2-b77c-8af32ba3eb36",
    // TODO: Replace with new client ID
    OAUTH_GOOGLE_CLIENT_ID: "542795358459-p468eja8rmvjqrc8i0j0rheiq8verq5k.apps.googleusercontent.com",
    OAUTH_FACEBOOK_CLIENT_ID: "3485340515103338",
    OAUTH_APPLE_CLIENT_ID: "com.govoutreach.ssostagingservice",
    OAUTH_APPLE_REDIRECT_URL: "https://api.staging.govoutreach.com/users/oauth/apple",

    NOTIFY_FACEBOOK_CLIENT_ID: "2026746284458885",
    NOTIFY_FACEBOOK_CALLBACK_URL: "http://localhost:3001/oauth2/facebook/callback",

    NOTIFY_TWITTER_CLIENT_ID: "bGFLU21fMmRyUEFxNmk2M0hqZXQ6MTpjaQ",
    NOTIFY_TWITTER_CALLBACK_URL: "http://localhost:3001/oauth2/twitter/callback",

    NOTIFY_INSTAGRAM_CLIENT_ID: "551546717959943",
    NOTIFY_INSTAGRAM_CALLBACK_URL: "https://localhost:3001/oauth2/instagram/callback",
    TINY_MCE_API_KEY: "nlfbk6tig41v8p95trrvq0v0aqrtiilhyopfzshv3l2pw3kk",
  },
  staging: {
    DIRECT_UPLOAD_BUCKET: "867089416966-gg-web-stg-attachments",
    CONTENT_URL: "https://attachments-staging.govoutreach.com",
    ATTACHMENTS_URL: "https://attachments.govoutreach.com",
    GOOGLE_GEOCODING_KEY: "AIzaSyDU1L0LwwZGDEOK7BfzwWiEwDN61pxOWxs",
    GOOGLE_MAP_KEY: "AIzaSyCIVurGluwQdJ8rvPltx8oRIzc76D3oAQk",
    ARCGIS_API_KEY:
      "AAPTxy8BH1VEsoebNVZXo8HurAf48IufKZdUJlhBoLKFbTf8sK9MEoFyrJ59hq3sMsTbBquPcj8PF8jwfaiJt5r1PEzjgkkloFePx0O7vfvuhHAtElLn4um3u8qRLOGrS4H8-s2qUI_0cNI2AH6pZ67-7cxQ6Vf0yO7d776r6FlqLvJ5dSvt5vOCavEv3amAndE6MZjdYtplcb3Vxfl4ktcbjc85qaJ6_ov70Mcl9ABydqs.AT1_j96gVLgS",
    GOGOV_APP_URL: "https://app-staging.govoutreach.com",
    GOGOV_WEB_API_URL: "https://user.staging.govoutreach.com",
    INTERNAL_ADMIN_URL: "https://internal-admin.staging.govoutreach.com",
    GOGOV_WEB_URL: "https://user.staging.govoutreach.com",
    GOGOV_MOBILE_URL: "https://m.staging.govoutreach.com",
    GOGOV_BASE_API_URL: "https://api.staging.govoutreach.com",
    CITIZEN_API_URL: "https://api.staging.govoutreach.com/citizen",
    CITIZENS_API_URL: "https://api.staging.govoutreach.com/citizens",
    IDENTITY_API_URL: "https://api.staging.govoutreach.com/users",
    PRODUCTS_API_URL: "https://api.staging.govoutreach.com/products",
    ADMIN_API_URL: "https://api.staging.govoutreach.com/admin",
    INTERNAL_ADMIN_API_URL: "https://internal-admin.staging.govoutreach.com/api",
    CALENDARS_API_URL: "https://api.staging.govoutreach.com/calendars",
    DIRECT_UPLOAD_API_URL: "https://api.staging.govoutreach.com/uploads",
    FILE_UPLOAD_API_URL: "https://api.staging.govoutreach.com/core/file",
    CORE_MOBILE_API_URL: "https://api.staging.govoutreach.com/core/mobile",
    EMPLOYEES_API_URL: "https://api.staging.govoutreach.com/employees",
    DEPARTMENTS_API_URL: "https://api.staging.govoutreach.com/departments",
    SEARCH_API_URL: "https://api.staging.govoutreach.com/search",
    CRM_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/crm/custom-fields",
    CE_SETTINGS_API_URL: "https://api.staging.govoutreach.com/admin/code",
    CE_CUSTOM_FIELDS_API_URL: "https://api.staging.govoutreach.com/ce/custom-fields",
    PERMITS_FORMS_API_URL: "https://api.staging.govoutreach.com/permits/forms",
    PERMITS_INSPECTION_TYPES_API_URL: "https://api.staging.govoutreach.com/inspections/types",
    PERMITS_INSPECTION_API_URL: "https://api.staging.govoutreach.com/inspections",
    PERMITS_TYPES_API_URL: "https://api.staging.govoutreach.com/permits/types",
    PERMITS_VIEWS_API_URL: "https://api.staging.govoutreach.com/permits/views",
    PERMITS_API_URL: "https://api.staging.govoutreach.com/permits",
    PERMITS_STATUSES_API_URL: "https://api.staging.govoutreach.com/permits/statuses",
    COMMENTS_API_URL: "https://api.staging.govoutreach.com/comments",
    PAYMENTS_API_URL: "https://api.staging.govoutreach.com/payments",
    DOCUMENT: "https://api.staging.govoutreach.com/documents",
    DOCUMENT_TYPES: "https://api.staging.govoutreach.com/documents/types",
    DOCUMENT_SETTINGS: "https://api.staging.govoutreach.com/admin/documents",
    NOTIFICATIONS_API_URL: "https://api.staging.govoutreach.com/notifications",
    FEATURE_FLAGS_API_URL: "https://api.staging.govoutreach.com/core/feature-flags",
    ASSETS_URL: "https://assets-staging.govoutreach.com",
    SYSTEM_STATUS_URL: "https://status.gogovapps.com",
    SENTRY_DSN: "https://143adbbe09b44249bb1c406a01b0fdac@o396450.ingest.sentry.io/5252806",
    STRIPE_TEST_PUBLIC_KEY:
      "pk_test_51Ij9KVDsqRmHarDvH3TkwaDO8qWMYQX4HHvOaYcwHw778vkslbRnsFMRzv5YOCVhl8AwZBMZrCfLv94Cq3nyB5te00pa1TI5fg",
    STRIPE_LIVE_PUBLIC_KEY:
      "pk_live_51Ij9KVDsqRmHarDvZHiL7Hkl1JBGJa92KJbXgPV6eWLzDvOHXuMtKaa5UsAeHGFna52U700G41VO9BYpPctmtMUP000YS7M36w",
    FORCE_NEW_LOOK_LISTS: false,
    MIXPANEL_TOKEN: "f11dfba8d1143733d77c4856ba2eed62",
    DATADOG_RUM_TOKEN: "pub6fca90cc7978f92d2bd1f73bdd90d702",
    DATADOG_RUM_APP_ID: "d0e40921-5139-4859-979f-fc3be06c5e2b",
    DISABLE_IMPORTS: false,
    DISABLE_EVENT_LOG: false,
    DISABLE_UPLOAD_TOOL: false,
    LOCAL_DEV_ENV: false,
    CONTACTS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/ContactsStandardImportTemplate.csv",
    MAP_LAYER_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/MapLayerStandardImportTemplate.csv",
    PERMITS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/PermitsStandardImportTemplate.csv",
    PERMIT_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/PermitAttachmentsStandardImportTemplate.csv",
    CRM_REQUESTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CRMRequestsStandardImportTemplate.csv",
    CRM_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CRMAttachmentsStandardImportTemplate.csv",
    CRM_LOGS_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/CRMLogsStandardImportTemplate.csv",
    CODE_CASES_IMPORT_TEMPLATE: "https://assets-staging.govoutreach.com/templates/CodeCasesStandardImportTemplate.csv",
    CODE_ACTIONS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeActionsStandardImportTemplate.csv",
    CODE_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeAttachmentsStandardImportTemplate.csv",
    CODE_VIOLATIONS_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeViolationsStandardImportTemplate.csv",
    CODE_ADDRESSES_IMPORT_TEMPLATE:
      "https://assets-staging.govoutreach.com/templates/CodeAddressesStandardImportTemplate.csv",
    RELEASE_NOTES_URL: "https://gogov.releasenotes.io/",
    EMAIL_SUPPRESSION_LIST_API_URL: "https://api.staging.govoutreach.com/core/mail/suppression-list",
    OAUTH_REDIRECT_URL: "https://app-staging.govoutreach.com/oauth/callback",
    OAUTH_MICROSOFT_CLIENT_ID: "c512dac5-5f5d-4041-890c-2a7d85be843e",
    OAUTH_GOGOV_CLIENT_ID: "ac9475d2-1a58-4ab4-ace2-08b6924af628",
    OAUTH_GOGOV_TENANT_ID: "b1888a2b-e5a6-47f2-b77c-8af32ba3eb36",
    // TODO: Replace with new client ID
    OAUTH_GOOGLE_CLIENT_ID: "542795358459-p468eja8rmvjqrc8i0j0rheiq8verq5k.apps.googleusercontent.com",
    OAUTH_FACEBOOK_CLIENT_ID: "3485340515103338",
    OAUTH_APPLE_CLIENT_ID: "com.govoutreach.ssostagingservice",
    OAUTH_APPLE_REDIRECT_URL: "https://api.staging.govoutreach.com/users/oauth/apple",

    NOTIFY_FACEBOOK_CLIENT_ID: "2026746284458885",
    NOTIFY_FACEBOOK_CALLBACK_URL: "https://app-staging.govoutreach.com/oauth2/facebook/callback",

    NOTIFY_TWITTER_CLIENT_ID: "bGFLU21fMmRyUEFxNmk2M0hqZXQ6MTpjaQ",
    NOTIFY_TWITTER_CALLBACK_URL: "https://app-staging.govoutreach.com/oauth2/twitter/callback",

    NOTIFY_INSTAGRAM_CLIENT_ID: "551546717959943",
    NOTIFY_INSTAGRAM_CALLBACK_URL: "https://app-staging.govoutreach.com/oauth2/instagram/callback",
    TINY_MCE_API_KEY: "nlfbk6tig41v8p95trrvq0v0aqrtiilhyopfzshv3l2pw3kk",
  },
  preprod: {
    DIRECT_UPLOAD_BUCKET: "867089416966-preprod-gg-web-stg-attachments",
    CONTENT_URL: "https://attachments-preprod.govoutreach.com",
    ATTACHMENTS_URL: "https://attachments.govoutreach.com",
    GOOGLE_GEOCODING_KEY: "AIzaSyDU1L0LwwZGDEOK7BfzwWiEwDN61pxOWxs",
    GOOGLE_MAP_KEY: "AIzaSyCIVurGluwQdJ8rvPltx8oRIzc76D3oAQk",
    ARCGIS_API_KEY:
      "AAPTxy8BH1VEsoebNVZXo8HurAf48IufKZdUJlhBoLKFbTf8sK9MEoFyrJ59hq3sMsTbBquPcj8PF8jwfaiJt5r1PEzjgkkloFePx0O7vfvuhHAtElLn4um3u8qRLOGrS4H8-s2qUI_0cNI2AH6pZ67-7cxQ6Vf0yO7d776r6FlqLvJ5dSvt5vOCavEv3amAndE6MZjdYtplcb3Vxfl4ktcbjc85qaJ6_ov70Mcl9ABydqs.AT1_j96gVLgS",
    GOGOV_APP_URL: "https://app-preprod.govoutreach.com",
    GOGOV_WEB_API_URL: "https://user.preprod.govoutreach.com",
    GOGOV_WEB_URL: "https://user.preprod.govoutreach.com",
    GOGOV_MOBILE_URL: "https://m.preprod.govoutreach.com",
    GOGOV_BASE_API_URL: "https://api.preprod.govoutreach.com",
    CITIZEN_API_URL: "https://api.preprod.govoutreach.com/citizen",
    CITIZENS_API_URL: "https://api.preprod.govoutreach.com/citizens",
    IDENTITY_API_URL: "https://api.preprod.govoutreach.com/users",
    PRODUCTS_API_URL: "https://api.preprod.govoutreach.com/products",
    ADMIN_API_URL: "https://api.preprod.govoutreach.com/admin",
    INTERNAL_ADMIN_URL: "https://internal-admin.staging.govoutreach.com",
    INTERNAL_ADMIN_API_URL: "https://internal-admin.staging.govoutreach.com/api",
    CALENDARS_API_URL: "https://api.preprod.govoutreach.com/calendars",
    DIRECT_UPLOAD_API_URL: "https://api.preprod.govoutreach.com/uploads",
    FILE_UPLOAD_API_URL: "https://api.preprod.govoutreach.com/core/file",
    CORE_MOBILE_API_URL: "https://api.preprod.govoutreach.com/core/mobile",
    EMPLOYEES_API_URL: "https://api.preprod.govoutreach.com/employees",
    DEPARTMENTS_API_URL: "https://api.preprod.govoutreach.com/departments",
    SEARCH_API_URL: "https://api.preprod.govoutreach.com/search",
    CRM_CUSTOM_FIELDS_API_URL: "https://api.preprod.govoutreach.com/crm/custom-fields",
    CE_SETTINGS_API_URL: "https://api.preprod.govoutreach.com/admin/code",
    CE_CUSTOM_FIELDS_API_URL: "https://api.preprod.govoutreach.com/ce/custom-fields",
    PERMITS_FORMS_API_URL: "https://api.preprod.govoutreach.com/permits/forms",
    PERMITS_INSPECTION_TYPES_API_URL: "https://api.preprod.govoutreach.com/inspections/types",
    PERMITS_INSPECTION_API_URL: "https://api.preprod.govoutreach.com/inspections",
    PERMITS_TYPES_API_URL: "https://api.preprod.govoutreach.com/permits/types",
    PERMITS_VIEWS_API_URL: "https://api.preprod.govoutreach.com/permits/views",
    PERMITS_API_URL: "https://api.preprod.govoutreach.com/permits",
    PERMITS_STATUSES_API_URL: "https://api.preprod.govoutreach.com/permits/statuses",
    COMMENTS_API_URL: "https://api.preprod.govoutreach.com/comments",
    PAYMENTS_API_URL: "https://api.preprod.govoutreach.com/payments",
    DOCUMENT: "https://api.preprod.govoutreach.com/documents",
    DOCUMENT_TYPES: "https://api.preprod.govoutreach.com/documents/types",
    DOCUMENT_SETTINGS: "https://api.preprod.govoutreach.com/admin/documents",
    NOTIFICATIONS_API_URL: "https://api.preprod.govoutreach.com/notifications",
    FEATURE_FLAGS_API_URL: "https://api.preprod.govoutreach.com/core/feature-flags",
    ASSETS_URL: "https://assets-preprod.govoutreach.com",
    SYSTEM_STATUS_URL: "https://status.gogovapps.com",
    SENTRY_DSN: "https://143adbbe09b44249bb1c406a01b0fdac@o396450.ingest.sentry.io/5252806",
    STRIPE_TEST_PUBLIC_KEY:
      "pk_test_51Ij9KVDsqRmHarDvH3TkwaDO8qWMYQX4HHvOaYcwHw778vkslbRnsFMRzv5YOCVhl8AwZBMZrCfLv94Cq3nyB5te00pa1TI5fg",
    STRIPE_LIVE_PUBLIC_KEY:
      "pk_live_51Ij9KVDsqRmHarDvZHiL7Hkl1JBGJa92KJbXgPV6eWLzDvOHXuMtKaa5UsAeHGFna52U700G41VO9BYpPctmtMUP000YS7M36w",
    FORCE_NEW_LOOK_LISTS: false,
    MIXPANEL_TOKEN: "f11dfba8d1143733d77c4856ba2eed62",
    DATADOG_RUM_TOKEN: "pub4a15b46b304feaeeebe81f49a1d8e05d",
    DATADOG_RUM_APP_ID: "be8d0dfc-dfb0-41f0-9f0d-b38c1b8c73f3",
    DISABLE_IMPORTS: false,
    DISABLE_EVENT_LOG: false,
    DISABLE_UPLOAD_TOOL: false,
    LOCAL_DEV_ENV: false,
    CONTACTS_IMPORT_TEMPLATE: "https://assets-preprod.govoutreach.com/templates/ContactsStandardImportTemplate.csv",
    MAP_LAYER_IMPORT_TEMPLATE: "https://assets-preprod.govoutreach.com/templates/MapLayerStandardImportTemplate.csv",
    PERMITS_IMPORT_TEMPLATE: "https://assets-preprod.govoutreach.com/templates/PermitsStandardImportTemplate.csv",
    PERMIT_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-preprod.govoutreach.com/templates/PermitAttachmentsStandardImportTemplate.csv",
    CRM_REQUESTS_IMPORT_TEMPLATE:
      "https://assets-preprod.govoutreach.com/templates/CRMRequestsStandardImportTemplate.csv",
    CRM_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-preprod.govoutreach.com/templates/CRMAttachmentsStandardImportTemplate.csv",
    CRM_LOGS_IMPORT_TEMPLATE: "https://assets-preprod.govoutreach.com/templates/CRMLogsStandardImportTemplate.csv",
    CODE_CASES_IMPORT_TEMPLATE: "https://assets-preprod.govoutreach.com/templates/CodeCasesStandardImportTemplate.csv",
    CODE_ACTIONS_IMPORT_TEMPLATE:
      "https://assets-preprod.govoutreach.com/templates/CodeActionsStandardImportTemplate.csv",
    CODE_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets-preprod.govoutreach.com/templates/CodeAttachmentsStandardImportTemplate.csv",
    CODE_VIOLATIONS_IMPORT_TEMPLATE:
      "https://assets-preprod.govoutreach.com/templates/CodeViolationsStandardImportTemplate.csv",
    CODE_ADDRESSES_IMPORT_TEMPLATE:
      "https://assets-preprod.govoutreach.com/templates/CodeAddressesStandardImportTemplate.csv",
    EMAIL_SUPPRESSION_LIST_API_URL: undefined,
    RELEASE_NOTES_URL: "https://gogov.releasenotes.io/",
    OAUTH_REDIRECT_URL: "https://app-preprod.govoutreach.com/oauth/callback",
    OAUTH_MICROSOFT_CLIENT_ID: "c512dac5-5f5d-4041-890c-2a7d85be843e",
    OAUTH_GOGOV_CLIENT_ID: "ac9475d2-1a58-4ab4-ace2-08b6924af628",
    OAUTH_GOGOV_TENANT_ID: "b1888a2b-e5a6-47f2-b77c-8af32ba3eb36",
    // TODO: Replace with new client ID
    OAUTH_GOOGLE_CLIENT_ID: "542795358459-p468eja8rmvjqrc8i0j0rheiq8verq5k.apps.googleusercontent.com",
    OAUTH_FACEBOOK_CLIENT_ID: "3485340515103338",
    OAUTH_APPLE_CLIENT_ID: "com.govoutreach.ssostagingservice",
    OAUTH_APPLE_REDIRECT_URL: "https://api.preprod.govoutreach.com/users/oauth/apple",

    NOTIFY_FACEBOOK_CLIENT_ID: "",
    NOTIFY_FACEBOOK_CALLBACK_URL: "",

    NOTIFY_TWITTER_CLIENT_ID: "",
    NOTIFY_TWITTER_CALLBACK_URL: "",

    NOTIFY_INSTAGRAM_CLIENT_ID: "",
    NOTIFY_INSTAGRAM_CALLBACK_URL: "",
    TINY_MCE_API_KEY: "nlfbk6tig41v8p95trrvq0v0aqrtiilhyopfzshv3l2pw3kk",
  },
  production: {
    DIRECT_UPLOAD_BUCKET: "331447492604-gg-web-prod-attachments",
    CONTENT_URL: "https://content.govoutreach.com",
    ATTACHMENTS_URL: "https://attachments.govoutreach.com",
    GOOGLE_GEOCODING_KEY: "AIzaSyC48hA-wwW2JTOFU5arMte7UJyLgd_RqAY",
    GOOGLE_MAP_KEY: "AIzaSyCIVurGluwQdJ8rvPltx8oRIzc76D3oAQk",
    ARCGIS_API_KEY:
      "AAPTxy8BH1VEsoebNVZXo8HurL1KO43PIePUt5tJzFu_EMf4m8JlGkTqYJXhEkeij9O8YaTxu7Bvd2VYFrdlL2vO-SLTRtHIIRRYqn3ztIS7Qtg4HuT4qE6npE6j7Vsj_bBH7WtRlgqVy-UDxwdNQiWTEW_6BRUPZ5nj0UwnGup3kCz4oXvxMSKXLhcmOM3gE6FhRj4CHBgiOJBFJBP8wXfeObplQXjB9dYzZ0JrTGUyrg4.AT1_7YapCJgy",
    GOGOV_APP_URL: "https://app.govoutreach.com",
    GOGOV_WEB_API_URL: "https://user.govoutreach.com",
    GOGOV_WEB_URL: "https://user.govoutreach.com",
    GOGOV_MOBILE_URL: "https://m.govoutreach.com",
    GOGOV_BASE_API_URL: "https://api.govoutreach.com",
    CITIZEN_API_URL: "https://api.govoutreach.com/citizen",
    CITIZENS_API_URL: "https://api.govoutreach.com/citizens",
    PRODUCTS_API_URL: "https://api.govoutreach.com/products",
    IDENTITY_API_URL: "https://api.govoutreach.com/users",
    ADMIN_API_URL: "https://api.govoutreach.com/admin",
    INTERNAL_ADMIN_API_URL: "https://internal-admin.govoutreach.com/api",
    INTERNAL_ADMIN_URL: "https://internal-admin.govoutreach.com",
    CALENDARS_API_URL: "https://api.govoutreach.com/calendars",
    DIRECT_UPLOAD_API_URL: "https://api.govoutreach.com/uploads",
    FILE_UPLOAD_API_URL: "https://api.govoutreach.com/core/file",
    CORE_MOBILE_API_URL: "https://api.govoutreach.com/core/mobile",
    EMPLOYEES_API_URL: "https://api.govoutreach.com/employees",
    DEPARTMENTS_API_URL: "https://api.govoutreach.com/departments",
    SEARCH_API_URL: "https://api.govoutreach.com/search",
    CRM_CUSTOM_FIELDS_API_URL: "https://api.govoutreach.com/crm/custom-fields",
    CE_SETTINGS_API_URL: "https://api.govoutreach.com/admin/code",
    CE_CUSTOM_FIELDS_API_URL: "https://api.govoutreach.com/ce/custom-fields",
    PERMITS_FORMS_API_URL: "https://api.govoutreach.com/permits/forms",
    PERMITS_INSPECTION_TYPES_API_URL: "https://api.govoutreach.com/inspections/types",
    PERMITS_INSPECTION_API_URL: "https://api.govoutreach.com/inspections",
    PERMITS_TYPES_API_URL: "https://api.govoutreach.com/permits/types",
    PERMITS_VIEWS_API_URL: "https://api.govoutreach.com/permits/views",
    PERMITS_API_URL: "https://api.govoutreach.com/permits",
    PERMITS_STATUSES_API_URL: "https://api.govoutreach.com/permits/statuses",
    COMMENTS_API_URL: "https://api.govoutreach.com/comments",
    PAYMENTS_API_URL: "https://api.govoutreach.com/payments",
    DOCUMENT: "https://api.govoutreach.com/documents",
    DOCUMENT_TYPES: "https://api.govoutreach.com/documents/types",
    DOCUMENT_SETTINGS: "https://api.govoutreach.com/admin/documents",
    NOTIFICATIONS_API_URL: "https://api.govoutreach.com/notifications",
    FEATURE_FLAGS_API_URL: "https://api.govoutreach.com/core/feature-flags",
    ASSETS_URL: "https://assets.govoutreach.com",
    SYSTEM_STATUS_URL: "https://status.gogovapps.com",
    SENTRY_DSN: "https://ac20efc379254bd58c674f2f25978496@o396450.ingest.sentry.io/5249806",
    STRIPE_LIVE_PUBLIC_KEY:
      "pk_live_51IkZA1Fe4VpqOTed7ixW3CZZeBiMtpv0N4YIDbw4r4LPFIqF3j6cBSZ8wnGYDCcFDyhU1bc5gGeYqjvuf3WBjXcO00q0r8oyCH",
    STRIPE_TEST_PUBLIC_KEY:
      "pk_test_51IkZA1Fe4VpqOTedTRaWW2h2DvL1PT9tLrG93W4wOpUog6PbM06BDjBXjsfue20YhlroQ16AFQhPR0ilBHrhKAAp00RHHIQYpK",
    FORCE_NEW_LOOK_LISTS: false,
    MIXPANEL_TOKEN: "d8f92e0ba42c678798a222435e26ed8f",
    DATADOG_RUM_TOKEN: "pub784caac90909316b1342981d49a91355",
    DATADOG_RUM_APP_ID: "516f01dc-a24c-4f3b-a694-d5698c3933fa",
    DISABLE_IMPORTS: true,
    DISABLE_UPLOAD_TOOL: false,
    DISABLE_EVENT_LOG: false,
    LOCAL_DEV_ENV: false,
    CONTACTS_IMPORT_TEMPLATE: "https://assets.govoutreach.com/templates/ContactsStandardImportTemplate.csv",
    MAP_LAYER_IMPORT_TEMPLATE: "https://assets.govoutreach.com/templates/MapLayerStandardImportTemplate.csv",
    PERMITS_IMPORT_TEMPLATE: "https://assets.govoutreach.com/templates/PermitsStandardImportTemplate.csv",
    PERMIT_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets.govoutreach.com/templates/PermitAttachmentsStandardImportTemplate.csv",
    CRM_REQUESTS_IMPORT_TEMPLATE: "https://assets.govoutreach.com/templates/CRMRequestsStandardImportTemplate.csv",
    CRM_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets.govoutreach.com/templates/CRMAttachmentsStandardImportTemplate.csv",
    CRM_LOGS_IMPORT_TEMPLATE: "https://assets.govoutreach.com/templates/CRMLogsStandardImportTemplate.csv",
    CODE_CASES_IMPORT_TEMPLATE: "https://assets.govoutreach.com/templates/CodeCasesStandardImportTemplate.csv",
    CODE_ACTIONS_IMPORT_TEMPLATE: "https://assets.govoutreach.com/templates/CodeActionsStandardImportTemplate.csv",
    CODE_ATTACHMENTS_IMPORT_TEMPLATE:
      "https://assets.govoutreach.com/templates/CodeAttachmentsStandardImportTemplate.csv",
    CODE_VIOLATIONS_IMPORT_TEMPLATE:
      "https://assets.govoutreach.com/templates/CodeViolationsStandardImportTemplate.csv",
    CODE_ADDRESSES_IMPORT_TEMPLATE: "https://assets.govoutreach.com/templates/CodeAddressesStandardImportTemplate.csv",
    RELEASE_NOTES_URL: "https://gogov.releasenotes.io/",
    EMAIL_SUPPRESSION_LIST_API_URL: "https://api.govoutreach.com/core/mail/suppression-list",
    OAUTH_REDIRECT_URL: "https://app.govoutreach.com/oauth/callback",
    OAUTH_MICROSOFT_CLIENT_ID: "8cc4c4b5-3ab8-422d-a3af-b80922c8e08e",
    OAUTH_GOGOV_CLIENT_ID: "27538b50-d2b7-41ab-883c-4c11bf7d8a02",
    OAUTH_GOGOV_TENANT_ID: "b1888a2b-e5a6-47f2-b77c-8af32ba3eb36",
    OAUTH_GOOGLE_CLIENT_ID: "235599045292-5ij4fhk89k80qjh0irn48rpfg1vg2d6q.apps.googleusercontent.com",
    OAUTH_FACEBOOK_CLIENT_ID: "627164779695440",
    OAUTH_APPLE_CLIENT_ID: "com.govoutreach.ssoproductionservice",
    OAUTH_APPLE_REDIRECT_URL: "https://api.govoutreach.com/users/oauth/apple",

    NOTIFY_FACEBOOK_CLIENT_ID: "966890282075779",
    NOTIFY_FACEBOOK_CALLBACK_URL: "https://app.govoutreach.com/oauth2/facebook/callback",

    NOTIFY_TWITTER_CLIENT_ID: "YjNaRk9hSnlpQWhZdWozaGhlTi06MTpjaQ",
    NOTIFY_TWITTER_CALLBACK_URL: "https://app.govoutreach.com/oauth2/twitter/callback",

    NOTIFY_INSTAGRAM_CLIENT_ID: "1062082585370377",
    NOTIFY_INSTAGRAM_CALLBACK_URL: "https://app.govoutreach.com/oauth2/instagram/callback",
    TINY_MCE_API_KEY: "nlfbk6tig41v8p95trrvq0v0aqrtiilhyopfzshv3l2pw3kk",
  },
};

/** @type {typeof config[keyof typeof config]} */
export const AppSettings = {
  ...config[import.meta.env.VITE_REACT_APP_STAGE || "development_staging"],
};
export default AppSettings;
